import styled from "styled-components";
import TextFieldComponent from "../";

export const TextField = styled(TextFieldComponent)<{ iconPosition?: "left" | "right" }>`
  padding-left: ${({ iconPosition }) => iconPosition === "left" && "45px"};
  padding-right: ${({ iconPosition }) => iconPosition === "right" && "45px"};
`;

export const IconWrapper = styled.div<{ iconPosition?: "left" | "right" }>`
  border-radius: ${({ iconPosition }) =>
    iconPosition === "left" ? "10px 0 0 10px" : "0 10px 10px 0"};

  position: absolute;
  left: ${({ iconPosition }) => iconPosition === "left" && "0"};
  right: ${({ iconPosition }) => iconPosition === "right" && "0"};
  background-color: ${({ theme }) => theme?.colors?.neutral.neutral10};
  bottom: 0;
  top: 0;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.9);
  z-index: 1;
`;
